import {convertDateHour, convertDateText} from "@/components/Telemetry/Dependencies/functions";

export function getChartOptions(data, color, unit, capacity, type) {
    return {
        series: [
            {
                name: 'Volume',
                data: data,
            },
        ],
        chartOptions: {
            chart: {
                type: 'area',
                height: 350,
                animations: {
                    enabled: true,
                    easing: 'easeinout',
                    speed: 5000,
                    animateGradually: {
                        enabled: true,
                        delay: 300,
                    },
                    dynamicAnimation: {
                        enabled: true,
                        speed: 1500,
                    },
                },
                toolbar: {
                    show: false,
                },
                zoom: {
                    enabled: false // Desabilita o efeito de zoom
                },
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.8,
                    opacityTo: 0.95,
                    colorStops: [
                        { offset: 0, color: '#00BFFF', opacity: 0.8 },
                        { offset: 100, color: '#007FFF', opacity: 0.3 },
                    ],
                },
            },
            stroke: {
                show: true,
                // width: 2,
                // curve: 'stepline',
                colors: [color],
            },
            dataLabels: {
                enabled: false,
            },
            yaxis: {
                min: 0,
                max: capacity,
                labels: {
                    formatter: (val) => `${parseFloat(val).toFixed(2)} ${unit}`,
                },
            },
            xaxis: {
                type: 'datetime',
                tickAmount: 10, // Define mais divisões no eixo X
                labels: {
                    format: 'dd/MM',
                    datetimeFormatter: {
                        day: 'dd MMM', // Exibe o dia e mês para aumentar a quantidade de datas visíveis
                    },
                },
            },
            tooltip: {
                y: {
                    formatter: (val) => `${parseFloat(val).toFixed(2)} ${unit}`,
                },
                x: {
                    formatter: function (val) {
                        if (type === 1) {
                            return convertDateHour(val);
                        } else {
                            return convertDateText(val);
                        }
                    },
                }
            },
        },
    };
}

